export default __webpack_public_path__ + "static/media/sunsetKlein.a5b045b1.jpg";